import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_RehabilitationMemberChoiceForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_RehabilitationMemberChoiceForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><b>Member Information:</b> I am requesting services from a mental health rehabilitation (MHR) provider. I understand that I
                    have the right to choose an agency to provide services to me or my child. I understand that I may only receive MHR
                    services from one provider unless my health plan makes an exception. I may change providers if I am not satisfied with the
                    services.</p>

                <p className='w-750'>If assistance is needed with finding an MHR provider, review the list of providers located at your health plan's website
                    below or call your plan for assistance.</p>

                <p className='w-750'>
                    <ol>
                        <li>Aetna: <a href='https://www.aetnabetterhealth.com/louisiana/find-provider'>https://www.aetnabetterhealth.com/louisiana/find-provider</a> &nbsp; or call 1-855-242-0802 Hearing impaired
                            TTY/TDD 711</li>
                        <li>Amerihealth Caritas Louisiana: <a href='http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx'>http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx</a> &nbsp; or 
                        call 1-888-756-0004; TTY 1-866-428-7588</li>
                        <li>Healthy Blue: <a href='https://www.myhealthybluela.com/la/care/find-a-doctor.html'>https://www.myhealthybluela.com/la/care/find-a-doctor.html</a> &nbsp; or call 1-844-227-8350 (TTY 711)</li>
                        <li>Louisiana Healthcare Connections: <a href='https://providersearch.louisianahealthconnect.com'>https://providersearch.louisianahealthconnect.com /</a> &nbsp; or call 1-866-595-
                            8133 (Hearing Loss: 711)</li>
                        <li>United Healthcare Community: <a href='http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html'>http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html</a> &nbsp; or 
                        call 1-866-675-1607 TTY: 1-877-4285-4514</li>
                    </ol>
                </p>

                <p className='w-750'><h3>The provider that I have freely selected to deliver MHR services to me or my child is:</h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name</span>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone Number</span>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Contact Name</span>
                            <input type='text' id='txtProviderContact' name='txtProviderContact' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address</span>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>By signing the form below, I understand that I have chosen to receive services from this MHR provider and I acknowledge
                    that it is my responsibility to notify my previous provider so they can coordinate my care with my new provider. I
                    understand that I am free to choose any MHR provider in my health plan's network.</p>

                <table>
                    <tr>
                        <td className='signature w-300'> </td>
                        <td className='signature w-300'> </td>
                        <td className='signature w-150'> </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Printed Legal Guardian Name (if applicable)</td>
                        <td className='small w-300'>Member/Legal Guardian Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><b>Providers Information:</b> A Member Choice form is required prior to receiving any mental health rehabilitation services. .
                    This form requires member/legal guardian signature, date, identified provider with telephone and contact name. The
                    provider is responsible for coordinating the transition of care with the member's previous provider prior to starting
                    services.</p>

                <table>
                    <tr>
                        <td className='signature w-600'> </td>
                        <td className='signature w-150'> </td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Provider Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











